import { Component, OnInit } from '@angular/core';
import { ReceiptService} from 'app/shared/services/receipt.service';
import { PaymentService} from 'app/shared/services/payment.service';
import { ExpenseService} from 'app/shared/services/expense.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-cheque-list',
  templateUrl: './cheque-list.component.html',
  styleUrls: ['./cheque-list.component.css']
})
export class ChequeListComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  isDark: boolean = false;

  receipts :any[];
  payment :any[];
  expense :any[];
  joinArray = [];
  finalArray = [];
  filteredList =[];
  fromDate : Date;
  toDate : Date;

  constructor( private receiptService : ReceiptService, 
               private paymentService : PaymentService, 
               private expenseService :ExpenseService, 
               private router : Router, 
               private themeService: NbThemeService,
               private decimalPipe : DecimalPipe
               ) 
               { 
 
                 this.datepickerConfig = Object.assign({},
                   {   
                     showWeekNumbers:false,
                     dateInputFormat : 'YYYY-MM-DD'
                   });
               }

  ngOnInit(): void {

    this.getAllTransaction();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
  }



  getAllTransaction(){
    var receiptfilter;
    var paymentFilter;
    var expFilter;
    var chequeFilterData;
    this.receiptService.getAll()
     .subscribe(
        (data) => {
                  receiptfilter = data;            
                 this.receipts  = receiptfilter.map(function(obj) {
                  return {transNo: obj.ReceiptNo,
                          transType : 'Receipt',
                          transDate: obj.PaidDate,
                          paymentType: obj.PaymentType,
                          description: obj.CusName,
                          cash_bank_account: obj.DepositAccount,
                          payRefNo: obj.PayRefNo,
                          amount: obj.AmountPaid
                        };
                  });
                  this.paymentService.getAll()
                  .subscribe(
                     (data) => {
                               paymentFilter = data;             
                               this.payment  = paymentFilter.map(function(obj) {
                                return {transNo: obj.VoucherNo,
                                        transType : 'Payment',
                                        transDate: obj.PaidDate,
                                        paymentType: obj.PaymentType,
                                        description: obj.SupName,
                                        cash_bank_account: obj.PaymentAccount,
                                        payRefNo: obj.PayRefNo,
                                        amount: (obj.AmountPaid *-1)
                                      };
                                });
                               this.expenseService.getAll()
                               .subscribe(
                                  (data) => {
                                            expFilter = data;           
                                            this.expense = expFilter.map(function(obj) {
                                              return {transNo: obj.ExpNo,
                                                      transType : 'Expense',
                                                      transDate: obj.ExpDate,
                                                      paymentType: obj.PaymentType,
                                                      description: obj.ExpName+'-'+obj.ExpCategory,
                                                      cash_bank_account: obj.PaymentAccount,
                                                      payRefNo: obj.PayRefNo,
                                                      amount: (obj.ExpTotal*-1)
                                                    };
                                              });
                                            this.joinArray.push(...this.receipts,...this.payment,...this.expense);
                                            chequeFilterData = this.joinArray.filter((el)=>{
                                              return el.paymentType ==="Cheque";
                                            });             
                                            this.finalArray = chequeFilterData.map(item=>Object.values(item));              
                                            this.filteredList=   this.finalArray; 

                                            },
                                 (err) => 
                                          {
                                            if(err instanceof HttpErrorResponse){                 
                                              if(err.status == 401){
                                                this.router.navigate(['/login']);
                                              }
                                            }
                                            console.log(err);
                                          });               
                               },
                    (err) => 
                             {
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                             });       

                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });        
       
     }


     getTotal(){
      return this.filteredList.map(totalBal=>totalBal[7]).reduce((acc,value)=>acc + +value,0);
      }

     viewBtnClicked(){
      if(this.fromDate && this.toDate){
          var startDate =moment(this.fromDate).format("YYYY-MM-DD");
          var endDate =moment(this.toDate).format("YYYY-MM-DD");
  
          this.filteredList = this.finalArray.filter(data => {
                var expDate = moment(data[2]).format("YYYY-MM-DD");              
                return moment(expDate).isBetween(startDate, endDate,undefined,'[]');              
                });

      }
      


    }

    clearBtnClicked(){
      this.fromDate = null;
      this.toDate = null;
      this.filteredList =   this.finalArray;  


     }

     savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'landscape',

        content: [   
          { text: 'Cheque List', style: 'reportHeader' }, 
          { text: (this.fromDate && this.toDate) ? `${moment(this.fromDate).format("YYYY-MM-DD")} To ${moment(this.toDate).format("YYYY-MM-DD")}` : '',alignment: 'center',margin: [0,5,0,5] }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', 'auto', 'auto', 'auto', '*', 'auto','auto'],  
                body: [  
                  
                  ['Type', 'PaymentType','Date', 'Cheque No', 'Description','Account', 'Amount'],               
                 ...this.filteredList.map(p => ([p[1],p[3],moment(p[2]).format("YYYY-MM-DD"),(p[6] ? p[6] : ''),p[4],p[5],{text : this.transformNumberFormat(p[7]), alignment: 'right'  }])),   
                  [ { text: `Total :`, bold: true, colSpan: 6 }, {},{},{},{},{}, { text :  this.transformNumberFormat(this.getTotal()),alignment: 'right', bold : true } ]  
                ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 10],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }



     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('expReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Cheque List.xlsx');
       
     }

     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
   }




}
